export default __webpack_public_path__ + "static/borderlinepuzzler-e850b537011d4e246ef13e190cea5520.jpg";